import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"
import { successDialog, errorDialog } from "../helpers/swal_helper"

export default class extends Controller {
  static targets = ["form", "startDate", "endDate"]

  connect() {
    this.setInitialMinDates()

    // Reset form when modal closes (Bootstrap event)
    this.element.addEventListener('hidden.bs.modal', this.clearForm.bind(this))
  }

  setInitialMinDates() {
    const today = new Date().toISOString().split('T')[0]
    this.startDateTarget.min = today
    this.endDateTarget.min = today
  }

  updateEndDateMin() {
    this.endDateTarget.min = this.startDateTarget.value
    if (this.endDateTarget.value && this.endDateTarget.value < this.startDateTarget.value) {
      this.endDateTarget.value = this.startDateTarget.value
    }
  }

  submitForm(event) {
    event.preventDefault()

    const formData = new FormData(event.target)
    const submitButton = event.target.querySelector('input[type="submit"], button[type="submit"]')

    Rails.ajax({
      url: event.target.action,
      type: "POST",
      data: formData,
      dataType: "json",
      success: (data) => {
        if (submitButton) submitButton.disabled = false

        if (data.success) {
          successDialog("Success", data.message)
          $('#authorisedAbsenceModal').modal('hide')
          location.reload()
        } else {
          errorDialog("Error", data.message)
        }
      },
      error: (xhr) => {
        if (submitButton) submitButton.disabled = false

        let errorMessage = "An error occurred. Please try again."
        if (xhr.responseJSON && xhr.responseJSON.message) {
          errorMessage = xhr.responseJSON.message
        }

        errorDialog("Error", errorMessage)
        console.error('Error:', xhr)
      }
    })
  }

  clearForm() {
    this.formTarget.reset()
    this.setInitialMinDates()
  }
}
